var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoritesFull = function SvgFavoritesFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7.1a5.52 5.52 0 0 0-3.9 1.6.19.19 0 0 1-.3 0A5.22 5.22 0 0 0 5.6 0h-.1A5.55 5.55 0 0 0 0 5.5C-.1 12.3 8.7 18.7 9.1 19a.5.5 0 0 0 .6 0c.4-.3 9.2-6.4 9.3-13.2v-.1A5.34 5.34 0 0 0 13.7.1"
  })));
};
export default SvgFavoritesFull;